import {
  SET_LOADING,
  SET_STORIES,
  REMOVE_STORY,
  HANDLE_PAGE,
  HANDLE_SEARCH,
} from './actions';

const reducer = (state, action) => 
{ 
  const { type } = action;
  if(type === SET_LOADING)
  {
    return { ...state, isLoading: true };
  }
  else if( type === SET_STORIES )
  {
    const { hits, nbPages } = action.payload;
    return { ...state, isLoading: false, hits, nbPages }
  }
  else if( type === REMOVE_STORY )
  {
    const id = action.payload;
    const hits = state.hits.filter((story) => story.objectID !== id );
    return { ...state, hits };
  }
  else if( type === HANDLE_SEARCH )
  {
    const query = action.payload;
    return { ...state, query, page: 0 };
  }
  else if( type === HANDLE_PAGE )
  {
    const page = action.payload;
    if (page === 'inc') 
    {
      let nextPage = state.page + 1;
      if (nextPage > state.nbPages - 1) 
      {
        nextPage = 0;
      }
      return { ...state, page: nextPage }
    }

    if (page === 'dec') 
    {
      let prevPage = state.page - 1;
      if (prevPage < 0) 
      {
        prevPage = state.nbPages - 1;
      }
      return { ...state, page: prevPage };
    }
  }
  else
  {
    throw new Error(`no mathching "${action.type}" action type`);
  }
  
}
export default reducer;
